
import Component from 'vue-class-component';
import Base from '@/shared/core/components/Base.vue';
import { SnackType } from '@/shared/core/events';
import {
  IsValidPriceRule,
  LengthRule,
  PositiveOrZeroNumberRule,
  ValidationRule,
} from '@/shared/core/validation/validation.rules';
import { Actions } from '@/shared/core/store/actions';
import { Getters } from '@/shared/core/store/getters';
import { Mutations } from '@/shared/core/store/mutations';
import { BalanceAlertConfiguration } from '../model/BalanceAlertConfiguration';
import { balanceAlertService } from '../services/balance-alert.service';

@Component({})
export default class ConfigBalanceAlert extends Base {
  get notThresholdRules(): ValidationRule[] {
    return [IsValidPriceRule, PositiveOrZeroNumberRule];
  }

  get notAlertMessageRules(): ValidationRule[] {
    return [LengthRule(0, 255)];
  }

  get balanceAlertConfiguration(): BalanceAlertConfiguration | null {
    return this.$store.getters[`balanceAlert/${Getters.BALANCE_ALERT_CONFIGURATION}`];
  }

  valid = false;

  deleteConfirmation = false;

  form: {
    alertThreshold: number | null;
    alertMessage: string | null | undefined;
  } = {
    alertThreshold: null,
    alertMessage: '',
  };

  mounted() {
    this.initForm();
  }

  initForm() {
    if (this.balanceAlertConfiguration) {
      this.form = {
        alertThreshold: this.balanceAlertConfiguration.alertThreshold,
        alertMessage: this.balanceAlertConfiguration.alertMessage,
      };
    }
    if (!this.balanceAlertConfiguration && this.site) {
      this.form = {
        alertThreshold: null,
        alertMessage: '',
      };
    }
  }

  async sendBalanceAlertConfiguration() {
    this.startLoading();

    if (this.site && this.form.alertThreshold != null) {
      const balanceAlertConfiguration: BalanceAlertConfiguration = {
        customerId: this.site.customerId,
        alertThreshold: this.form.alertThreshold,
        alertMessage: this.form.alertMessage,
      };

      if (this.balanceAlertConfiguration) {
        await balanceAlertService.updateBookingConfiguration(balanceAlertConfiguration).then(
          async () => {
            this.snack(`Configuration modifiée avec succès`);
            this.$store.dispatch(
              `balanceAlert/${Actions.SET_BALANCE_ALERT_CONFIGURATION}`,
              this.site?.customerId,
              { root: true },
            );
          },
          (e) => {
            this.snack(
              e.response?.data?.message ||
                `Erreur pendant la sauvegarde de vos modifications (${e.response?.status})`,
              SnackType.ERROR,
            );
          },
        );
      } else {
        await balanceAlertService.createBookingConfiguration(balanceAlertConfiguration).then(
          async () => {
            this.snack(`Configuration créée avec succès`);
            this.$store.dispatch(
              `balanceAlert/${Actions.SET_BALANCE_ALERT_CONFIGURATION}`,
              this.site?.customerId,
              { root: true },
            );
          },
          (e) => {
            this.snack(
              e.response?.data?.message ||
                `Erreur pendant la sauvegarde de vos modifications (${e.response?.status})`,
              SnackType.ERROR,
            );
          },
        );
      }
    }
    this.releaseLoading();
  }

  async deleteBalanceAlertConfiguration() {
    this.startLoading();
    if (this.balanceAlertConfiguration) {
      await balanceAlertService
        .deletebalanceAlertConfiguration(this.balanceAlertConfiguration.customerId)
        .then(
          async () => {
            this.snack(`Configuration supprimée avec succès`);
            this.$store.commit(`balanceAlert/${Mutations.SET_BALANCE_ALERT_CONFIGURATION}`, null, {
              root: true,
            });
            if (this.$refs.form) {
              const form = this.$refs.form as HTMLFormElement;
              form.reset();
            }
            this.deleteConfirmation = false;
          },
          (e) => {
            this.snack(
              e.response?.data?.message ||
                `Erreur pendant la suppression de la configuration (${e.response?.status})`,
              SnackType.ERROR,
            );
          },
        );
    }
    this.releaseLoading();
  }
}
